window.ko_dic = {
    'plan': '계획',
    'common.calendar.january': '일월',
    'common.calendar.february': '이월',
    'common.calendar.march': '삼월',
    'common.calendar.april': '사월',
    'common.calendar.may': '오월',
    'common.calendar.june': '유월',
    'common.calendar.july': '칠월',
    'common.calendar.august': '팔월',
    'common.calendar.september': '구월',
    'common.calendar.october': '시월',
    'common.calendar.november': '십일월',
    'common.calendar.december': '십이월',
    'common.calendar.sunday.short': '일',
    'common.calendar.monday.short': '월',
    'common.calendar.tuesday.short': '화',
    'common.calendar.wednesday.short': '수',
    'common.calendar.thursday.short': '목',
    'common.calendar.friday.short': '금',
    'common.calendar.saturday.short': '토',
    'common.label.roomCount': '방',
    'common.label.mailAddressEmptyError': '당신의 이메일 주소를 입력하십시오.',
    'common.label.mailAddressCharacterCountError': '이메일 주소를 254자 이내로 입력하세요.',
    'common.label.mailAddressIncorrectError': '올바른 이메일 주소를 입력하세요.',
    'GCER001F00100.label.countryCodeEmptyError': '연락처 정보(국가 코드)를 입력하세요.',
    'GCER001F00100.label.countryCodeCharacterCountError': '연락처(국가번호)는 5자리 이내로 입력해주세요.',
    'GCER001F00100.label.countryCodeIncorrectError': '정확한 연락처 정보(국가 코드)를 입력하세요.',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin5': '연락처(지역번호)는 5자 이내로 입력해주세요.',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin9': '연락처(지역번호)는 9자 이내로 입력해주세요.',
    'common.label.areaCodeIncorrectError': '연락처(지역번호)를 정확히 입력해주세요.',
    'common.label.cityCodeCharacterCountErrorWithin4': '연락처(도시번호)는 4자리 이내로 입력해주세요.',
    'GCER001F00100.label.cityCodeCharacterCountErrorWithin9': '연락처(도시번호)는 9자 이내로 입력해주세요.',
    'common.label.cityCodeIncorrectError': '연락처(도시번호)를 정확히 입력해주세요.',
    'common.label.subscriberNumberCharacterCountErrorWithin4': '연락처(가입자번호)는 4자 이내로 입력해주세요.',
    'GCER001F00100.label.subscriberNumberCharacterCountErrorWithin9': '연락처(가입자번호)는 9자 이내로 입력해주세요.',
    'common.label.subscriberNumberIncorrectError':'연락처(가입자번호)를 정확히 입력해주세요.',
    'GCER001F00100.label.areaCodeEmptyError': '연락처(지역번호)를 입력해주세요.',
    'GCER001F00100.label.cityCodeEmptyError': '연락처(도시코드)를 입력해주세요.',
    'GCER001F00100.label.subscriberNumberEmptyError': '연락처(가입자번호)를 입력해주세요.',
    'common.label.reservationNumberEmptyError': '예약번호를 입력해주세요.',
    'common.label.reservationNumberCharacterCountError': '예약번호는 19자 이내로 입력해주세요.',
    'common.label.passwordEmptyError': '비밀번호를 입력하세요.',
    'common.label.passwordCharacterCountError': '비밀번호는 최대 64자까지 입력하세요.',
    'common.label.authenticationError': '인증을 실행할 때 오류가 발생했습니다. 인증 화면을 새로고침 후 인증을 다시 해주세요.',
    'common.label.snsAuthenticationFail': 'SNS 인증에 실패했습니다.',
    'GCER001F00100.label.failSnsLogin': 'SNS 로그인에 실패했습니다.',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin3': '연락처(지역번호)는 3자리 이내로 입력해주세요.',
    'common.label.unexpectedLoginError': '로그인 중 예기치 않은 오류가 발생했습니다.',
    'common.label.sun': '일',
    'common.label.mon': '월',
    'common.label.tue': '화',
    'common.label.wed': '수',
    'common.label.thu': '목',
    'common.label.fri': '금',
    'common.label.sat': '토',
    'common.label.gender.male': '남성',
    'common.label.gender.female': '여성',
    'common.label.gender.other': '기타',
    'common.label.adult': '성인',
    'common.label.guestCount': '명',
    'common.label.comma': ', ',
    'common.label.others': '다른',
    'common.label.yen': '엔',
    'common.label.paymentFailMessage': '결제 실패. 시스템 관리자에게 문의하십시오.',
    'common.label.mailAddressIncorrectFormatError': '이메일 주소를 올바른 이메일 주소 형식으로 입력하세요.',
    'common.label.welcomeInformation1-1': '환영 이메일은 숙박 1주일 ',
    'common.label.welcomeInformation1-2': '전에 예약을 알리는 이메일입니다.',
    'common.label.welcomeInformation2': '* 단, 숙박 3일 전에 유사한 메일이 발송됩니다.',
    'common.label.welcomeInformation3': '귀하의 이메일은 항상 귀하에게 전송됩니다.',
    'common.label.thankYouInformation': '감사 이메일은 숙박 후 발송되는 이메일입니다.',
    'common.label.chargeDetails':'청구내역',
    'common.label.nightNumber': '박',
    'common.label.roomNumber': '방',
    'common.label.memberDiscount': '회원 할인',
    'common.label.subtotal': '소계',
    'common.label.totalRoomRate': '총',
    'common.label.pointYenEquivalent': '포인트',
    'common.label.pointBalanceAmount': '사용 가능한 포인트',
    'common.label.usableMaxLimit.point': '사용 가능한 최대 포인트：{0}',
    'common.label.usableMinLimit.point': '사용 가능한 최소 포인트：{0}',
    'common.label.usableRange.point': '{0}-{1}포인트 이용 가능합니다.',
    'common.label.usableUnit.point': '(포인트 사용 단위{0})',
    'common.label.usableUnit.point.help': '{0}포인트 단위로 이용가능합니다.',
    'common.label.pointToGrantSuffix.point': '{0} 포인트',
    'common.label.use': '사용',
    'common.label.useAll': '모두 사용',
    'coupon.message.applyCode' : '추가 쿠폰.',
    'coupon.message.getCoupon' : '쿠폰을 얻었다.',
    'coupon.message.getCoupon.failed' : '쿠폰을 받을 수 없습니다.',
    'GRES006F02600.label.lodgingNumChangeCautionWord': '* 인원을 추가할 수 없습니다. 추가를 원하시면 다시 예약해주세요.',
    'GRES006F02600.label.lodgingNumPriceEmptyCautionWord': '지정하신 총 인원수에 하여 예약을 접수할 수 없습니다.',
    'GRES006F02600.label.lodgingDateNumChangeCautionWord': '* 숙박일수는 늘릴 수 없습니다. 늘리고 싶으면 다시 예약하세요.',
    'GRES006F02600.label.optionChangeWord': '* 예약 접수 기간 외이므로 선택 불가',
    'GRES006F02600.label.kanaInformation': '히라가나로 입력하세요.',
    'GRES006F02600.label.mailInformation1': '오타 방지를 위해 같은 이메일 주소를 두 곳에 입력해주세요.',
    'GRES006F02600.label.mailInformation2': '모바일 이메일 주소를 입력하실 경우 이메일 필터 설정에 주의해주세요.',
    'GRES006F02600.label.mailInformation3': '인터넷 메일 수신 불가로 설정하시면 예약 확인 메일을 받으실 수 없습니다.',
    'GRES006F02600.label.contactInformation': '반각 숫자만 입력하세요.',
    'common.label.addressZipMark': '',
    'GRES015F04300.label.reservationAcceptanceSuspension': '죄송합니다. 현재는 예약을 받지 않습니다.',
    'GRES015F04300.label.planAcceptanceSuspension': '죄송합니다. 현재, 우리는 지정된 계획을 수락하지 않습니다.',
    'GRES015F04300.label.roomAcceptanceSuspension': '죄송합니다. 현재 지정실 접수는 마감되어 있습니다.',
    'GRES001F02100.label.returnPlanList' : '계획 목록으로 돌아가기',
    'GRES001F02100.validation.emptyNameError' : '성명은필수항목입니다.입력해 주세요.',
    'GRES001F02100.validation.wrongNameError' : '특수 기호, 환경의존 문자를 제외하고 입력하세요.',
    'GRES001F02100.validation.emptyNameKanaError' : '',
    'GRES001F02100.validation.wrongNameKanaError' : '',
    'GRES001F02100.validation.emptyMailAddressError' : '이메일 주소는 필수 항목입니다.입력해 주세요.',
    'GRES001F02100.validation.wrongMailAddressError' : '유효한 형식으로 입력해 주세요.',
    'GRES001F02100.validation.emptyMailAddressConfirmError' : '이메일 주소는 필수 항목입니다.입력해 주세요.',
    'GRES001F02100.validation.unmatchMailAddressConfirmError' : '이메일 주소가 일치하도록 입력해주세요.',
    'GRES001F02100.validation.emptyTelError' : '연락처는 필수항목입니다.반각숫자로입력하세요.',
    'GRES001F02100.validation.wrongTelError' : '반각숫자로입력하세요.',
    'GRES001F02100.validation.tooShortTelAreaError' : '시외국번은 2문자 이상 5문자 이내의 반각 숫자로 입력해 주십시오.',
    'GRES001F02100.validation.tooLongTelError' : '7자 이상 15자 이내의 반각 숫자로 입력해 주십시오.',
    'GRES001F02100.validation.emptyLodgerGender' : '성별은 필수 항목입니다.선택해 주세요.',
    'GRES001F02100.validation.emptyPassword' : '비밀번호는 필수항목입니다.반각영수(대·소문자 포함) 8~64자리수로 입력해주세요.',
    'GRES001F02100.validation.wrongPassword' : '반각영수(대·소문자 포함) 8~64자리수로 설정해주세요.',
    'GRES001F02100.validation.emptyBirthday' : '생년월일은 필수항목입니다.선택해 주세요.',
    'GRES001F02100.validation.notRequiredEmptyBirthday' : '생년월일을 선택하세요.',
    'GRES001F02100.validation.emptyZipCode' : '우편번호는 필수항목입니다. 반각숫자로입력하세요.',
    'GRES001F02100.validation.wrongZipCode' : '반각숫자로입력하세요.',
    'GRES001F02100.validation.emptyAddressPrefectures' : '주소는 필수 항목입니다.',
    'GRES001F02100.validation.emptyAddress' : '주소는 필수 항목입니다.입력해 주세요.',
    'GRES001F02100.validation.emptyCreditCardNo' : '카드번호는 필수항목입니다.반각숫자 14-16자리로 입력해 주세요.',
    'GRES001F02100.validation.wrongCreditCardNo' : '반각숫자 14-16자리로 입력해 주세요.',
    'GRES001F02100.validation.emptySecurityCode' : '보안 코드는 필수 항목입니다.반각숫자 3자리 또는 4자리로 입력해주세요.',
    'GRES001F02100.validation.wrongSecurityCode' : '반각숫자 3자리 또는 4자리로 입력해주세요.',
    'GRES001F02100.validation.emptyCreditCardName' : '카드명의는 필수항목입니다.입력해 주세요.',
    'GRES001F02100.validation.wrongCreditCardName' : '카드명의는유효한형식으로입력하세요.',
    'GRES001F02100.validation.emptyCreditCardExpire' : '카드 유효기간은 필수항목입니다.선택해 주세요.',
    'GRES001F02100.validation.wrongCreditCardExpire' : '과거 날짜가 선택되어 있습니다.미래의 날짜를 선택하세요.',
    'GRES001F02100.validation.tooLongTextArea' : '200자 이내로 입력해주세요',
    'GRES001F02100.validation.emptyContractCompany' : '필수항목입니다.입력하세요.',
    'GRES001F02100.validation.emptyContractCompanyPassword' : '비밀번호는 필수항목입니다.입력하세요.',
    'GRES001F02100.validation.wrongContractCompanyPassword' : '반각 영숫자 기호를 입력하세요.',
    'GRES001F02100.validation.unmatchLodgerGender' : '예약 인원과 일치하도록 선택해 주세요.',
    'GRES001F02100.validation.emptyQuestionTextAnswer' : '필수항목입니다.입력하세요.',
    'GRES001F02100.validation.tooLongQuestionTextAnswer' : '200자 이내로 입력해주세요.',
    'GRES001F02100.validation.emptyQuestionSelectAnswer' : '필수 항목입니다. 선택해주세요.',
    'GRES001F02100.validation.emptyQuestionCheckboxAnswer' : '필수 항목입니다. 선택해주세요.',
    'GRES001F02100.validation.couponCodeError' : '입력한 코드에 대한 쿠폰을 찾을 수 없습니다. 입력한 세부 정보를 확인하십시오.',
    'GRES001F02100.validation.couponCodeDuplicatedError' : '쿠폰이 이미 추가되었습니다.',

    'coupon.label.more': '추가 정보.▼',
    'coupon.label.close': '추가 정보.▲',

    'coupon.banner.title.member': '회원가입 후',
    'coupon.banner.title': '할인쿠폰으로 예약비를 절약하세요!',
    'coupon.banner.title.button': '추가 정보 ▶',
    'coupon.modal.title': '회원으로 가입하시면 특별 쿠폰을 이용하실 수 있습니다',
    'coupon.modal.title.member': '배포 중인 쿠폰 목록',
    'coupon.modal.caution': '각 쿠폰마다 획득 및 사용 조건이 다릅니다.',
    'coupon.modal.desc.1': '쿠폰 할인은 객실 요금에 적용됩니다. 추가 옵션 요금에는 할인이 적용되지 않습니다.',
    'coupon.modal.desc.2': '적립한 쿠폰은 예약 시 최고의 거래 및 조합에 자동으로 적용됩니다.',
    'coupon.modal.desc.3': '쿠폰 배포 예정 수량이 종료되거나 예산 및 기타 사유로 쿠폰이 조기에 종료될 수 있습니다.',
    'coupon.modal.desc.4': '예약 시간에 따라 이미 예약한 경우에도 이용할 수 없는 경우가 있습니다.',
    'coupon.modal.membership': '이미 등록된 경우',
    'coupon.modal.memberLogin': '로그인',
    'coupon.modal.memberRegister': '회원가입',
    'coupon.modal.has.otherCoupons': '쿠폰은 다른 날짜에 사용할 수 있습니다',
    'coupon.badge.couponTarget': '쿠폰 자격요',
    'coupon.badge.banner.title': '최고의 쿠폰을 받으세요',

    'coupon.label.code': '（{{code}}）',
    'coupon.label.discountAmount.upper': '예약 합계에서',
    'coupon.label.discountAmount.upper_false': '1인당 또는 객실당',
    'coupon.label.discountAmount': '{{amount, number}}엔 할인',
    'coupon.label.discountAmount_rate': '{{amount, number}}% 디스카운트',
    'coupon.label.discountAmount.has.zeroDiscount': '혜택',
    'coupon.label.canUseTogether_true': '다른 쿠폰과 함께 사용할 수 있습니다',
    'coupon.label.canUseTogether_false': '다른 쿠폰과 함께 사용할 수 없습니다',
    'coupon.label.discountLimit': '최대 할인 금액은{{amount, number}}엔입니다.',
    'coupon.label.discountLimit_plan': '최대 할인은 1인당 1박에 {{amount, number}}엔입니다.',
    'coupon.label.fromTotalBookings.not': '* 요금제에 따라 1인당 1박 요금 또는 객실 1박 요금이 할인됩니다.',
    'coupon.label.useQuantityLimit': '선착순 최대{{amount, number}}부',
    'coupon.label.targetPlans': '적용 가능한 요금제:',
    'coupon.label.availableMonths': '취득 후{{months}}개월입니다',
    'coupon.label.expiredAt': '만료 날짜:',
    'coupon.label.neverExpires': '만료 날짜 없음',
    'coupon.label.stayAt': '투숙기간 :',
    'coupon.label.periodRange': '{{- day.start}}～{{- day.end}}',
    'coupon.label.periodRangeCheck': '{{- day.start}}체크인～{{- day.end}}체크아웃',
    'coupon.label.unavailableDays': '제외일: ',
    'coupon.label.unavailablePeriod': '제외 기간:',
    'coupon.label.useCondition': '{{amount, number}}엔 이상의 예약이 가능합니다',
    'coupon.label.remainingTimes': '최대 {{amount, number}}회까지 사용 가능（표준{{remains, number}}회）',
    'coupon.label.remainingTimes.limit': '최대 {{amount, number}}회까지 사용 가능',
    'coupon.label.remainingTimes.one': '한 번만 사용할 수 있습니다 ',
    'coupon.label.remainingTimes.noLimit': '원하는 횟수만큼 사용할 수 있습니다',
    'coupon.label.acquired': '이미 획득된',
    'coupon.label.acquiring': '얻어요',
    'coupon.message.unable.useAmountLimit' : '캠페인이 종료되어 사용할 수 없습니다.',
    'coupon.message.unable.useQuantityLimit' : '캠페인이 종료되어 사용할 수 없습니다.',
    'coupon.message.unable.ended' : '캠페인이 종료되어 사용할 수 없습니다.',
    'coupon.message.unable.notApplied' : '사용 예정인 쿠폰과 함께 사용할 수 없습니다.',

    'common.message.temporaryError': '일시적인 오류가 발생했습니다. 페이지를 다시 로드하고 업데이트하세요.',
    'common.label.required': '필수',
};
